// extracted by mini-css-extract-plugin
module.exports = {"root":"tags-bar-module--root--1ildC","contentRoot":"tags-bar-module--contentRoot--3rHJn","link":"tags-bar-module--link--2PA-5","selected":"tags-bar-module--selected--21z6F"};